import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Outlet,
  Route,
  Navigate,
} from 'react-router-dom';
import { ThemeProvider as HexaThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { Toaster } from './components/ui/toaster';
import { DocumentUploadProvider } from './contexts/DocumentUploadContext';
import { DocumentIndexingProvider } from './contexts/DocumentIndexingContext';
import { AgentPageContextProvider } from './contexts/AgentPageContext';

import LoginPage from './components/LoginPage';
import ContactsPageNew from './pages/ContactsPageNew';
import TaskPageWrapper from './pages/TaskPageWrapper';
import DashboardNewPage from './pages/DashboardNewPage';
import AgendaPageNew from './pages/AgendaPageNew';
import TeamPageWrapper from './pages/TeamPageWrapper';
import NotesPage from './pages/NotesPage';
import NoteDetailPage from './pages/NoteDetailPage';
import TelegramSettingsPage from './pages/TelegramSettingsPage';
import DocumentsPage from './pages/DocumentsPage';
import LeadsPageWrapper from './plugins/leads/pages/LeadsPageWrapper';
import MailAccountsPage from './pages/MailAccountsPage';
import MailInboxPage from './pages/MailInboxPage';
import { MailCompositionProvider } from './contexts/MailCompositionContext';
import { MailCompositionNavigationGuard } from './components/mail/MailCompositionNavigationGuard';
import MailDraftsPage from './pages/MailDraftsPage';
import MailComposePage from './pages/MailComposePage';
import MailOAuthCallbackPage from './pages/MailOAuthCallbackPage';
import './plugins/leads';
import { ModuleRoute } from './components/common/ModuleRoute';
import { useSwNavigation } from './hooks/useSwNavigation';



function MailLayout() {
  useSwNavigation();
  return <MailCompositionProvider><MailCompositionNavigationGuard /><Outlet /></MailCompositionProvider>;
}
const router = createBrowserRouter(createRoutesFromElements(
    <Route element={<MailLayout />}>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/contacts" element={<ContactsPageNew />} />
      <Route path="/tasks" element={<TaskPageWrapper />} />
      <Route path="/team" element={<TeamPageWrapper />} />
      <Route path="/dashboard-new" element={<DashboardNewPage />} />
      <Route path="/agenda" element={<AgendaPageNew />} />
      <Route path="/notes" element={<NotesPage />} />
      <Route path="/notes/:id" element={<NoteDetailPage />} />
      <Route path="/documents" element={<DocumentsPage />} />
      <Route path="/documents/spaces/:spaceId" element={<DocumentsPage />} />
      <Route path="/documents/spaces/:spaceId/folders/:folderId" element={<DocumentsPage />} />
      <Route path="/documents/spaces/:spaceId/files/:fileId" element={<DocumentsPage />} />
      <Route path="/documents/views/:view" element={<DocumentsPage />} />
      <Route path="/settings/telegram" element={<TelegramSettingsPage />} />
      <Route path="/leads" element={
        <ModuleRoute module="leads">
          <LeadsPageWrapper />
        </ModuleRoute>
      } />
      <Route path="/mail/accounts" element={<ModuleRoute module="emails"><MailAccountsPage /></ModuleRoute>} />
      <Route path="/mail/inbox" element={<ModuleRoute module="emails"><MailInboxPage /></ModuleRoute>} />
      <Route path="/mail/drafts" element={<ModuleRoute module="emails"><MailDraftsPage /></ModuleRoute>} />
      <Route path="/mail/compose" element={<ModuleRoute module="emails"><MailComposePage /></ModuleRoute>} />
      <Route path="/mail/oauth/callback" element={<MailOAuthCallbackPage />} />
      <Route path="*" element={<div>404 - Pagina non trovata</div>} />
    </Route>
));

function App() {
  return (
    <HexaThemeProvider>
      <UserProvider>
        <NotificationsProvider>
          <DocumentUploadProvider>
            <DocumentIndexingProvider>
            <AgentPageContextProvider>
          <div style={{ display: 'flex', minWidth: 0 }}>
            <div style={{ flex: 1, minWidth: 0, position: 'relative' }}>
              <RouterProvider router={router} />
            </div>
          </div>
          <Toaster />
            </AgentPageContextProvider>
            </DocumentIndexingProvider>
          </DocumentUploadProvider>
        </NotificationsProvider>
      </UserProvider>
    </HexaThemeProvider>
  );
}

export default App;
